const thunkMiddleware = store => next => action => (
  typeof action === 'function'
    ? action(store.dispatch, store.getState)
    : next(action)
);

export default thunkMiddleware;



// WEBPACK FOOTER //
// ./src/thunk-middleware.js